import React, { useContext, useState, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationPin, faVialCircleCheck, faFaceFrownOpen, faFrownOpen } from '@fortawesome/free-solid-svg-icons';
import { renderToString } from 'react-dom/server';
import { Button } from 'react-bootstrap';
import L from 'leaflet';


import './providerList.css';
import { DevContext } from "../context";
import { useBreakpoints } from "../hooks";
import { ProviderDto, ProviderAuxiliaryDataDto } from "../../models";
import API from "../../lib/devApi";

const customIcon = <FontAwesomeIcon icon={faLocationPin} fontSize={52} />
const selectedIcon = <FontAwesomeIcon icon={faLocationPin} style={{color: "gray !important"}} fontSize={36} />

const divIcon = L.divIcon({
    html: renderToString(customIcon),
    iconSize: [30, 42],
    iconAnchor: [15, 42],
    className: "icon-bg"
})

const divSelectedIcon = L.divIcon({
    html: renderToString(selectedIcon),
    iconSize: [30, 42],
    iconAnchor: [15, 42],
    className: "icon-bg"
})


export default function ProviderList({showOnMobile = false, ...props} : any) {
    const breakpoint = useBreakpoints();
    const { mapContext, providerSearchParams, setSelectedProvider, providers, setShowLoading, setProviderAuxiliaryData } = useContext(DevContext);

    const [listContainerWidth, setListContainerWidth] = useState(window.innerWidth);

    let _listContainerStyle = {};
    switch(breakpoint) {
        case "xs":
        case "sm":
        case "md":
            _listContainerStyle = {width: listContainerWidth};
            break;
        case "lg":
        case "xl":
        case "xxl":
            _listContainerStyle = {}; //height: window.innerHeight
            break;
    }

    const [listContainerStyle, setListContainerStyle] = useState(_listContainerStyle);

    const onListItemClick = (provider: ProviderDto) => {
        if(mapContext && mapContext.current) {
            let currentMarker;
            mapContext.current.eachLayer((layer) => {
                currentMarker = layer as L.Marker;
                if(currentMarker.setIcon) {
                    if(provider.name == currentMarker.options.title) {
                        currentMarker.setIcon(divIcon);
                    }
                    else {
                        currentMarker.setIcon(divSelectedIcon);
                    }
                }
                // console.log(layer as L.Marker);
            });

            mapContext.current.panTo([provider.latitude, provider.longitude])
        }
    }

    const viewProviderDetail = async (provider: ProviderDto) => {
        try {
            setShowLoading(true);
            const result = await API.GetProviderAuxiliaryData(provider.providerId);
            setProviderAuxiliaryData(result);
            setSelectedProvider(provider);
        } catch (error) {
            
        }
        finally {
            setShowLoading(false);
        }
        
    }

    return (
        <React.Fragment>
            <div className="list-container" style={listContainerStyle} >
                {providers? providers.items.length > 0? providers.items.map((provider: ProviderDto, idx: number) => {
                    return (
                        <div onClick={() => onListItemClick(provider)} key={idx} className="list-item-container">
                            <div className="list-item">
                                <div className="list-item-text">
                                    <h2 style={{margin: 0}}>{provider.name}</h2>
                                    {/* {provider.isOpen?
                                        <span style={{color: "green", fontWeight: 700}}>Abierto para vacunación contra el COVID-19</span>
                                        :
                                        <span style={{color: "red", fontWeight: 700}}>Cerrado para vacunación contra el COVID-19</span>
                                    } */}
                                </div>
                                {
                                    breakpoint == "xs" || breakpoint == "sm" || breakpoint == "md"?
                                    <>
                                        {/* {
                                            providerSearchParams && providerSearchParams.vaccines && providerSearchParams.vaccines.length > 0?
                                            <>
                                                <br />
                                                <div>
                                                    <h5>Vacunas:</h5>
                                                    <ListGroup variant="flush">
                                                        {provider.vaccines.map((vaccine, idx) => {
                                                            if(providerSearchParams && providerSearchParams.vaccines) {
                                                                const found = providerSearchParams.vaccines.find((value: string) => {
                                                                    return value == vaccine.vaccineId;
                                                                });

                                                                if(found) {
                                                                    return <ListGroup.Item key={idx}><FontAwesomeIcon icon={faVialCircleCheck} style={{color: "green"}} fontSize={24} />&nbsp;{vaccine.name}&nbsp;</ListGroup.Item>
                                                                }
                                                            }
                                                        })}
                                                    </ListGroup>
                                                </div>
                                            </>
                                            : <></>
                                        } */}
                                    </>:
                                    <>
                                        <br />
                                        <div className="list-item-text">
                                            <p>{provider.address}<br></br><a target="_blank" href={`https://www.google.com/maps/search/?api=1&query=${provider.latitude}%2C${provider.longitude}`}>Ver Dirección en Google Maps.</a></p>
                                        </div>
                                        
                                        <div className="list-item-text">
                                            <a href={`tel:+1${provider.phone.replace(" ", "").replace("(", "").replace(")", "").replace("-", "")}`}>{provider.phone}</a>
                                            {provider.ext && provider.ext != ""? <p>Ext {provider.ext}</p>: <br />}
                                        </div>

                                        <div className="list-item-text">
                                            {provider.altPhone && provider.altPhone != ""? <a href={`tel:+1${provider.altPhone.replace(" ", "").replace("(", "").replace(")", "").replace("-", "")}`}>{provider.altPhone}</a>: <></>}
                                            {provider.altExt && provider.altExt != ""? <p>Ext {provider.altExt}</p>: <br />}
                                        </div>
                                        
                                        <div className="list-item-text">
                                            {provider.email && provider.email !=""? <p>{provider.email}</p> : <br />}
                                        </div>

                                        {
                                            providerSearchParams && providerSearchParams.vaccines && providerSearchParams.vaccines.length > 0?
                                            <>
                                                <div className="list-item-text">
                                                    <h5>Vacunas:</h5>
                                                    {provider.vaccines.map((vaccine, idx) => {
                                                        if(providerSearchParams && providerSearchParams.vaccines) {
                                                            const found = providerSearchParams.vaccines.find((value: string) => {
                                                                return value == vaccine.vaccineId;
                                                            });

                                                            if(found) {
                                                                return <span key={idx}><FontAwesomeIcon icon={faVialCircleCheck} style={{color: "green"}} fontSize={24} />&nbsp;{vaccine.name}</span>
                                                            }
                                                        }
                                                    })}
                                                </div>
                                            </>
                                            : <></>
                                        }
                                    </>
                                }
                            </div>
                            <div>
                                <Button variant="see-more" onClick={() => viewProviderDetail(provider)} size="lg">Ver m&aacute;s</Button>
                                {/* <span onClick={() => viewProviderDetail(provider)} className="list-item-select-lnk">Ver m&aacute;s</span> */}
                            </div>
                        </div>
                    )
                }) :
                <>
                    <div className="no-results">
                        <FontAwesomeIcon icon={faFrownOpen} style={{color: "#496966"}} fontSize={70} />
                        <br />
                        <br />
                        <p>No se encontraron proveedores de vacunaci&oacute;n.</p>
                    </div>
                </> : <></>
                }
            </div>

        </React.Fragment>
    )
}